import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { createAuth } from "../actions/auth"
import { fetchMedications } from "../actions/medications"
import { updateUserInfo } from "../actions/users"

const DataLoader = ({ children }) => {
  const auth = useSelector((s) => s.auth)
  const dispatch = useDispatch()
  const [token, setToken] = useState()
  const [fetchedData, setFetchedData] = useState(false)

  useEffect(() => {
    const storedToken = window.localStorage.getItem("token")
    setToken(storedToken)
    if (storedToken) {
      const user = JSON.parse(window.localStorage.getItem("user"))
      dispatch(createAuth(user, storedToken))
    }
  }, [dispatch])

  useEffect(() => {
    if (token && auth && !fetchedData) {
      dispatch(updateUserInfo())
      setFetchedData(true)
    } else if (!auth && fetchedData) {
      setFetchedData(false)
    }
  }, [auth, fetchedData, dispatch, token])

  useEffect(() => {
    dispatch(fetchMedications())
  }, [dispatch])

  return children
}

DataLoader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default DataLoader
